import { getAuth } from "firebase/auth";

const API_BASE = (import.meta?.env?.VITE_API_BASE || "").replace(/\/$/, "");

function apiUrl(path) {
  return `${API_BASE}${path}`;
}

async function getAuthToken() {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      console.warn("getAuthToken: Nenhum usuário autenticado no Firebase Auth");
      return null;
    }
    const token = await user.getIdToken();
    console.log("getAuthToken: Token obtido com sucesso para", user.email);
    return token;
  } catch (err) {
    console.error("getAuthToken: Erro ao obter token", err);
    return null;
  }
}

async function readMaybeJson(res) {
  const raw = await res.text();
  let data = null;
  try {
    data = JSON.parse(raw);
  } catch {
    data = null;
  }
  const looksHtml = typeof raw === "string" && raw.trim().startsWith("<");
  return { raw, data, looksHtml };
}

export async function apiGetRelatoriosGrupo(grupoId) {
  const token = await getAuthToken();
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(apiUrl(`/api/opcoes/relatorios/grupo/${encodeURIComponent(grupoId)}`), {
    headers,
  });
  const { data, looksHtml } = await readMaybeJson(res);
  if (looksHtml) throw new Error("HTML_RESPONSE");
  if (!res.ok || !data?.ok) throw new Error(data?.error || "Falha ao carregar logo do grupo");
  return data.config;
}

export async function apiUploadLogoRelatorioGrupo({ grupoId, file }) {
  const token = await getAuthToken();
  if (!token) {
    throw new Error("Usuário não autenticado. Faça login e tente novamente.");
  }

  console.log("apiUploadLogoRelatorioGrupo: Iniciando upload para", grupoId);
  
  const fd = new FormData();
  fd.append("grupoId", grupoId);
  fd.append("logo", file);

  try {
    const url = apiUrl(`/api/opcoes/relatorios/grupo/logo`);
    console.log("apiUploadLogoRelatorioGrupo: Enviando para", url);
    
    const res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: fd,
    });
    
    console.log("apiUploadLogoRelatorioGrupo: Resposta status", res.status);
    
    const { data, looksHtml } = await readMaybeJson(res);
    if (looksHtml) throw new Error("Servidor retornou HTML (erro geral)");
    if (!res.ok || !data?.ok) {
      const errorMsg = data?.error || "Falha ao enviar logo do grupo";
      throw new Error(errorMsg);
    }
    
    console.log("apiUploadLogoRelatorioGrupo: Upload bem-sucedido");
    return data.config;
  } catch (err) {
    console.error("apiUploadLogoRelatorioGrupo: Erro", err);
    throw err;
  }
}
